



import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import Tiffins from "../all items.jpg";
import menu1 from "../menu1.jpg";
import logo from "../banner2.jpg";
import Digitlfoodsidebar from "../Component/Digitlfoodsidebar.js";
import Offersmenu from "./Offersmenu";
import Festivaloffers from "./Festivaloffers";
// import FlatOffers from "./FlatOffers";
// import SuperOffers from "./SuperOffers";
import  SidescrollAdvertisements from './SidescrollAdvertisements';
import AllIcon from "../menu1.jpg";
import { useLoader } from "././Context/LoaderProvider.jsx";
import { useParams } from "react-router-dom";

import festivalImg from "../menu1.jpg";
import flatImg from "../menu1.jpg";
import superImg from "../menu1.jpg";
import Newnavbar from '../Newnavbar'
import FestivalOfferspage from'./FestivalOfferspage';

const Allorderaccepts = ({ setShowLogin }) => {
  const [activeCategory, setActiveCategory] = useState("Allitems");
  const [activeOffer, setActiveOffer] = useState("offersmenu"); // Default to main menu
  const [parentId, setParentId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [dishes, setDishes] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
  const [bannerData, setBannerData] = useState(null);
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();

  const [coupons, setCoupons] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoSliding, setIsAutoSliding] = useState(true);
  const autoSlideRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const { vendorId } = useParams();

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Calculate visible items per slide based on screen size
  const getVisibleItems = () => {
    if (window.innerWidth <= 320) return 2;
    if (window.innerWidth <= 480) return 3;
    if (window.innerWidth <= 768) return 4;
    return 5;
  };

  // Fetch categories and dishes
  useEffect(() => {
    showLoader();

    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) {
      hideLoader();
      return;
    }

    const token = localStorage.getItem("authToken");

    fetch(
      ` https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        const cats = data.filter(
          (item) => item.parentId === 0 || item.parentId === null
        );
        const dis = data.filter(
          (item) => item.parentId !== 0 && item.parentId !== null
        );
        setCategories(cats);
        setDishes(dis);
      })
      .catch((err) => console.error("❌ Error fetching data:", err))
      .finally(() => {
        hideLoader();
      });
  }, []);

  // Fetch banner data
  useEffect(() => {
    showLoader();

    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) {
      hideLoader();
      return;
    }

    const token = localStorage.getItem("authToken");

    axios
      .get(
        ` https://backend.maamaas.com/food/api/sbanner/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        setBannerData({
          ...data,
          companyName: data.companyName || "No Name",
        });
      })
      .catch(() => {
        console.error("❌ Could not load banner details.");
      })
      .finally(() => {
        hideLoader();
      });
  }, []);

  useEffect(() => {
    showLoader();

    const vendorId = localStorage.getItem("vendorId") || 3;
    const token = localStorage.getItem("authToken");

    axios
      .get(
        ` https://backend.maamaas.com/food/api/banner/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setBannerData({
          ...res.data,
          companyName: res.data.companyName,
        });
      })
      .catch((err) => {
        console.error("❌ Failed to fetch vendor banner:", err);
      })
      .finally(() => {
        hideLoader();
      });
  }, []);

  // Handle category click
  const handleClick = (categoryName) => {
    if (categoryName === "Allitems") {
      setParentId(null);
      setActiveCategory("Allitems");
      return;
    }

    const selected = categories.find(
      (cat) =>
        cat.dishName.trim().toLowerCase() ===
        categoryName.trim().toLowerCase()
    );

    if (selected) {
      setParentId(selected.dishId);
      setActiveCategory(categoryName);
    } else {
      setParentId(null);
      setActiveCategory("Allitems");
    }
  };

  // Handle offer type click
  const handleOfferClick = (offerType) => {
    setActiveOffer(offerType);
    // Reset category filter when switching offers
    setParentId(null);
    setActiveCategory("Allitems");
  };

  // Sample offers
  useEffect(() => {
    setCoupons([
      { code: "PIZZA50", discountPercentage: 50, dishId: 1 },
      { code: "BURGER30", discountPercentage: 30, dishId: 2 },
      { code: "DEL99", discountPercentage: 20, dishId: 3 },
    ]);
  }, []);

  // Get all categories for slider
  const getAllCategories = () => {
    return [
      { name: "All", value: "Allitems", isAll: true },
      ...categories.map(cat => ({ 
        name: cat.dishName, 
        value: cat.dishName, 
        isAll: false 
      }))
    ];
  };

  // Get total slides
  const getTotalSlides = () => {
    const visibleItems = getVisibleItems();
    const allCats = getAllCategories();
    return Math.ceil(allCats.length / visibleItems);
  };

  // Handle next slide
  const nextSlide = () => {
    const totalSlides = getTotalSlides();
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
    pauseAutoSlide();
  };

  // Handle previous slide
  const prevSlide = () => {
    const totalSlides = getTotalSlides();
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    pauseAutoSlide();
  };

  // Pause auto slide
  const pauseAutoSlide = () => {
    setIsAutoSliding(false);
    if (autoSlideRef.current) {
      clearInterval(autoSlideRef.current);
    }
    
    // Resume auto slide after 5 seconds
    setTimeout(() => {
      setIsAutoSliding(true);
    }, 5000);
  };

  // Auto slide functionality
  useEffect(() => {
    if (isMobile && isAutoSliding) {
      autoSlideRef.current = setInterval(() => {
        const totalSlides = getTotalSlides();
        setCurrentSlide(prev => (prev + 1) % totalSlides);
      }, 3000);
    }

    return () => {
      if (autoSlideRef.current) {
        clearInterval(autoSlideRef.current);
      }
    };
  }, [isMobile, isAutoSliding, categories.length]);

  // Get visible categories for current slide
  const getVisibleCategories = () => {
    const visibleItems = getVisibleItems();
    const allCats = getAllCategories();
    const startIndex = currentSlide * visibleItems;
    const endIndex = startIndex + visibleItems;
    return allCats.slice(startIndex, endIndex);
  };

  const offers = [
    {
      name: "All Offers",
      type: "offersmenu",
      img: AllIcon,
    },
    {
      name: "Festival Offers",
      type: "festival",
      img: festivalImg,
    },
    {
      name: "Flat Offers",
      type: "flat",
      img: flatImg,
    },
    // {
    //   name: "Super Offers",
    //   type: "super",
    //   img: superImg,
    // },
    
  ];


  // Add this function before the return statement
const getShortName = (name) => {
  const shortNames = {
    "Festival Offers": "Festival",
    "Flat Offers": "Flat",
    "Super Offers": "Super",
    "Main Menu": "Menu"
  };
  return shortNames[name] || name.split(' ')[0];
};
  // Render the active component based on activeOffer state
  const renderActiveComponent = () => {
    switch (activeOffer) {
      case "festival":
        return <Festivaloffers parentId={parentId} setShowLogin={setShowLogin} searchQuery={searchQuery} />;
      case "flat":
        return <FestivalOfferspage parentId={parentId} setShowLogin={setShowLogin} searchQuery={searchQuery} />;
      case "super":
        return <Festivaloffers parentId={parentId} setShowLogin={setShowLogin} searchQuery={searchQuery} />;
      case "offersmenu":
      default:
        return <Offersmenu parentId={parentId} setShowLogin={setShowLogin} searchQuery={searchQuery} />;
    }
  };

  return (
    <>
      <div>
        <Newnavbar />
      </div>

      <p
        style={{
          position: "relative",
          top: "55px",
          background: "#fff",
          padding: "10px",
          fontWeight: "bold",
          fontSize: isMobile ? "14px" : "18px",
          display: isMobile ? "" : "block",
          marginLeft: "40px",
          marginTop: "10px",
        }}
      >
        <Link to="/" style={{ color: "rgb(177, 92, 214)", textDecoration: "none" }}>
          Home
        </Link>
        
        <span className="separator"> &gt; </span>

        <Link
         
          style={{ textDecoration: "none" }}
        >
          <span
            style={{
              color: "#ee6521",
              fontWeight: "bold",
              fontSize: isMobile ? "14px" : "inherit",
            }}
          >
            {bannerData?.companyName || "Maamaas"}
          </span>
        </Link>

        {" > "}
        <Link
          to=""
          style={{
            color: "rgb(177, 92, 214)",
            fontWeight: "bold",
            textDecoration: "none",
          }}
        >
          Deals
        </Link>
      </p>

      <div
        className="container-fluid main-layout"
        style={{
          display: "flex",
          marginTop: "38px",
          height: "calc(100vh - 38px)",
          overflow: "hidden",
        }}
      >
        {/* Sidebar - Responsive */}
       <div
  className={`sidebar ${isMobile ? 'col-12' : isTablet ? 'col-md-3' : 'col-lg-2 col-md-3'}`}
  style={{
    flexShrink: 0,
    background: "#fff",
    marginTop: "35px",
    padding: isMobile ? "10px 5px" : "10px 20px",
    display: "flex",
    flexDirection: isMobile ? "row" : "column",
    flexWrap: isMobile ? "nowrap" : "nowrap",
    justifyContent: isMobile ? "space-between" : "flex-start",
    alignItems: "stretch",
    gap: isMobile ? "5px" : "10px",
    overflowX: isMobile ? "auto" : "hidden",
    position: isMobile ? "sticky" : "relative",
    top: isMobile ? "0" : "auto",
    zIndex: isMobile ? 100 : 1,
   
    height: isMobile ? "50px" : "auto",
    minHeight: isMobile ? "50px" : "auto",
  }}
>
  {offers.map((offer, index) => (
    <button
      key={index}
      onClick={() => handleOfferClick(offer.type)}
      style={{
        background: activeOffer === offer.type 
          ? "rgb(144, 50, 168)" 
          : "#ee6521",
        borderRadius: isMobile ? "10px" : "15px",
        padding: isMobile ? "6px 10px" : "16px 10px",
        margin: 0,
        cursor: "pointer",
        textAlign: "center",
        transition: "all 0.3s ease",
        border: activeOffer === offer.type ? 
          "2px solid #fff" : 
          "none",
        boxShadow: activeOffer === offer.type ? 
          "0 2px 8px rgba(0,0,0,0.2)" : 
          "0 1px 3px rgba(0,0,0,0.1)",
        flex: isMobile ? "1 1 0px" : "0 1 auto",
        minWidth: isMobile ? "0" : "auto",
        height: isMobile ? "35px" : "auto",
        display: "flex",
        flexDirection: isMobile ? "column" : "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "0",
        outline: "none",
      }}
      onMouseEnter={(e) => {
        if (!isMobile) e.currentTarget.style.transform = "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        if (!isMobile) e.currentTarget.style.transform = "scale(1)";
      }}
    >
      {/* Circular Image - Only show in desktop */}
      {!isMobile && (
        <img
          src={offer.img}
          alt={offer.name}
          style={{
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "3px solid #fff",
            marginBottom: "10px",
          }}
        />
      )}
      
      {/* Text - Shortened for mobile */}
      <span
        style={{
          color: "#fff",
          fontWeight: "bold",
          fontSize: isMobile ? "11px" : "14px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
        }}
      >
        {isMobile ? getShortName(offer.name) : offer.name}
      </span>
    </button>
  ))}
</div>

        {/* Main Content - Scrollable */}
        <div
          className={`main-content ${isMobile ? 'col-12' : isTablet ? 'col-md-6' : 'col-lg-7 col-md-6'}`}
          style={{
            overflowY: "auto",
            padding: isMobile ? "0 10px" : "0 15px",
            marginTop: isMobile ? "10px" : "20px",
            height: isMobile ? "auto" : "100%",
            minHeight: isMobile ? "calc(100vh - 150px)" : "auto"
          }}
        >
          {/* Render the active component */}
          {renderActiveComponent()}
        </div>

        {/* Right Offers - Responsive */}
        <div
          className={`right-offers ${isMobile ? 'd-none' : ''}`}
          style={{
            display: isMobile ? "none" : isTablet ? "none" : "block",
            position: "sticky",
            top: "40px",
            height: "calc(100vh - 80px)",
            overflowY: "auto"
          }}
        >
          <SidescrollAdvertisements />
        </div>
      </div>

      {/* Enhanced CSS for responsiveness */}
      <style>
        {`
          * {
            box-sizing: border-box;
          }
          
          .container-fluid {
            padding: 0 !important;
            margin: 0 !important;
            width: 100% !important;
          }

          /* Hide scrollbars but allow scrolling */
          .main-content::-webkit-scrollbar,
          .sidebar::-webkit-scrollbar {
            display: none;
          }
          .main-content,
          .sidebar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }

          /* Main layout - FIXED */
          .main-layout {
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            display: flex;
            min-height: 100vh;
            overflow: visible !important;
          }

          /* Mobile */
          @media (max-width: 768px) {
            .main-layout {
              flex-direction: column;
              height: auto;
              margin-top: 20px;
              overflow: visible !important;
            }
            .mobile-scroll-drop{
              margin-top:90px!important;
            }
            .sidebar {
              width: 100% !important;
              margin-top: -10px;
              overflow: visible !important;
              height: auto !important;
            }
            
            .main-content {
              width: 100% !important;
              margin-top: 15px;
              padding: 0 10px;
              overflow: visible !important;
            }
            
            /* Hide scrollbar for mobile horizontal scroll */
            div[style*="overflow-x: auto"]::-webkit-scrollbar {
              display: none;
            }
            
            /* Smooth slide animation */
            .smooth-slide {
              transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
            }
          }

          @media (max-width: 425px) {
            .main-layout {
              flex-direction: column;
              height: auto;
              margin-top: 20px;
              overflow: visible !important;
            }
            
            .sidebar {
              width: 100% !important;
              margin-top: -10px;
              overflow: visible !important;
              height: auto !important;
              padding-bottom: -40px;
            }
            
            .main-content {
              width: 100% !important;
              margin-top: 15px;
              padding: 0 10px;
              overflow: visible !important;
            }
          }

          /* Tablet (769px - 1023px) */
          @media (min-width: 769px) and (max-width: 1023px) {
            .main-layout {
              height: auto;
              min-height: 100vh;
              overflow: visible !important;
            }
            
            .sidebar {
              width: 25% !important;
              flex: 0 0 25% !important;
              margin-top: 10px;
              max-width: 250px;
              position: relative;
              height: auto;
              overflow-y: auto !important;
              overflow-x: hidden;
            }
            .mobile-scroll-drop{
              margin-top:120px!important;
            }
            .main-content {
              width: 75% !important;
              flex: 1 !important;
              margin-top: 30px;
              padding: 0 20px;
              height: auto;
              overflow-y: auto;
            }

            .right-offers {
              width: 20% !important;
              position: relative;
              height: auto;
              overflow-y: auto;
            }
          }

          /* Large Screens (1024px and above) - NO SCROLLING */
          @media (min-width: 1024px) {
            .main-layout {
              height: calc(100vh - 38px) !important;
              min-height: auto;
              overflow: hidden !important;
            }
            .mobile-scroll-drop{
              margin-top:120px!important;
            }
            .sidebar {
              width: 25% !important;
              flex: 0 0 25% !important;
              margin-top: 10px;
              max-width: 250px;
              position: relative;
              height: 100% !important;
              overflow-y: hidden !important;
              overflow-x: hidden;
            }
            
            .main-content {
              width: 75% !important;
              flex: 1 !important;
              margin-top: 30px;
              padding: 0 20px;
              height: 100% !important;
              overflow-y: hidden !important;
            }

            .right-offers {
              width: 20% !important;
              position: relative;
              height: 100% !important;
              overflow-y: hidden !important;
            }

            /* Mobile horizontal scroll for tabs */
@media (max-width: 768px) {
  .sidebar {
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  
  .sidebar::-webkit-scrollbar {
    display: none;
  }
  
  /* Ensure buttons don't wrap */
  .sidebar > div, .sidebar > button {
    flex-shrink: 0;
  }
}
          }

          body {
            background-color: white;
            overflow-x: hidden;
            overflow-y: auto !important;
          }

          html {
            overflow-y: auto !important;
          }
        `}
      </style>
    </>
  );
};

export default Allorderaccepts;